module.exports = __webpack_public_path__ + "img/ml4.4d622a42.jpg";